import { Component } from "react";

import { CREATerms } from "@components/CreaTerms";
import { InfiniteScroll } from "@components/base";

import { get } from "../.../../../rest_client";
import { toQueryParams } from "../../query";

import { PropertyListingsSearchFilters } from "./PropertyListingsSearchFilters";
import type { Filters } from "./PropertyListingsSearchFilters";
import { PropertyListingsSearchResults } from "./PropertyListingsSearchResults";

const limit = 25;

interface State extends Partial<Filters> {
  loading: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  propertyListings: any[]; // TODO: change to something more specific once this is migrated to GQL
  searchQuery?: string;
  timeout?: NodeJS.Timeout;
  displayCreaTerms: boolean;
}

export class PropertyListingsSearch extends Component<object, State> {
  state: State = {
    loading: true,
    propertyListings: [],
    displayCreaTerms: false,
  };

  componentDidMount() {
    this.loadPropertyListings();
  }

  handleFilterSubmit = (filters: Filters) => {
    this.setState(
      {
        sort_by: filters.sort_by,
        property_types: filters.property_types,
        number_of_bedrooms: filters.number_of_bedrooms,
        number_of_bathrooms: filters.number_of_bathrooms,
        price_min: filters.price_min,
        price_max: filters.price_max,
        loading: true,
      },
      () => {
        this.loadPropertyListings();
      },
    );
  };

  handleFormSubmit = (searchQuery: string) => {
    this.setState({ searchQuery, loading: true }, () => {
      const { timeout } = this.state;
      if (timeout) {
        clearTimeout(timeout);
      }

      const tempTimeout = setTimeout(() => {
        const { timeout } = this.state;
        this.loadPropertyListings();
        if (timeout) {
          clearTimeout(timeout);
        }
      }, 600);

      this.setState({ timeout: tempTimeout });
    });
  };

  buildRequestURL = (offset?: number) => {
    const {
      searchQuery,
      sort_by,
      number_of_bedrooms,
      number_of_bathrooms,
      price_max,
      price_min,
      property_types,
    } = this.state;

    const data = {
      search_query: searchQuery,
      sort_by,
      property_types,
      number_of_bedrooms,
      number_of_bathrooms,
      price_max,
      price_min,
      limit,
      offset: offset || 0,
    };

    return `/property_listings?${toQueryParams(data)}`;
  };

  loadPropertyListings = (offset?: number) => {
    get(
      this.buildRequestURL(offset),
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (propertyListings: any) => {
        let newPropertyListings = propertyListings;

        if (offset) {
          newPropertyListings = [...this.state.propertyListings, ...propertyListings];
        }

        this.setState({
          loading: false,
          propertyListings: newPropertyListings,
        });
      },
      ({ status }) => {
        if (status === 403) {
          this.setState({ displayCreaTerms: true });
        }
      },
    );
  };

  render() {
    const { displayCreaTerms, propertyListings, loading, searchQuery } = this.state;

    if (displayCreaTerms) {
      return (
        <CREATerms
          onAccepted={() => {
            this.setState({ displayCreaTerms: false }, () => {
              this.loadPropertyListings();
            });
          }}
        />
      );
    }

    return (
      <InfiniteScroll
        loadingData={loading}
        onInfiniteScroll={this.loadPropertyListings}
        limit={limit}
        resourceCount={propertyListings.length}
      >
        <div id="property-listings-search-component" className="margin-top-container">
          <PropertyListingsSearchFilters handleFilterSubmit={this.handleFilterSubmit} />

          <PropertyListingsSearchResults
            searchQuery={searchQuery}
            propertyListings={propertyListings}
            handleFormSubmit={this.handleFormSubmit}
            loading={loading}
          />

          <div className="clear" />
        </div>
      </InfiniteScroll>
    );
  }
}
